
import Wind2 from "../../../assets/filled/Wind2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Wind2Icon({ className, dataTestid = "Wind2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Wind2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
